import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, SxProps } from '@mui/material';
import { ReactElement } from 'react';

import { DynamicTooltip } from './DynamicTooltip';

export const TooltipInfo = ({
    content,
    isSecondaryColor,
    isError,
    color,
    leaveDelay,
    interactive,
    sx,
}: {
    content: string | ReactElement;
    isSecondaryColor?: boolean;
    isError?: boolean;
    color?: string;
    leaveDelay?: number;
    interactive?: boolean;
    sx?: SxProps;
}) => {
    const renderContent = () => {
        if (typeof content === 'object' && content.type === 'img') {
            return (
                <img
                    src={content.props.src}
                    alt={content.props.alt}
                    style={{
                        display: 'block',
                        width: content.props.width,
                        height: content.props.height,
                        margin: '-6px -16px',
                    }}
                />
            );
        } else {
            return content;
        }
    };

    const iconElement = isError ? (
        <ErrorOutlineIcon
            data-testclass="icon-tooltip"
            sx={{
                color: '#FF0000',
            }}
        />
    ) : (
        <InfoOutlinedIcon
            data-testclass="icon-tooltip"
            sx={{
                color: color || (isSecondaryColor ? 'grey.400' : 'primary'),
            }}
        />
    );

    return (
        <DynamicTooltip
            content={renderContent()}
            maxWidth={684}
            enterDelay={200}
            leaveDelay={leaveDelay}
            interactive={interactive}
        >
            <Box sx={sx}>{iconElement}</Box>
        </DynamicTooltip>
    );
};
